import { BaseModel } from './base.model';

export const MapUserFields = {
  full_name: 'Nome Completo',
  first_name: 'Nome',
  last_name: 'Sobrenome',
  email: 'E-mail',
  phone: 'Telefone',
  session_time: 'Tempo de Sessão',
  is_active: 'Ativo',
  is_staff: 'Funcionário',
  is_superuser: 'Administrador',
  authToken: 'Token',
};

export class User extends BaseModel {
  full_name: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  session_time: number;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  authToken: string;

  static fromJson(jsonData: any): User {
    return Object.assign(new User(), jsonData);
  }

  getMapFields() {
    return MapUserFields;
  }
}
